export default "__VITE_ASSET__BCj2wCRy__"